export default __webpack_public_path__ + "static/media/elmer703.1e574231.jpg";